import Auth from '@aws-amplify/auth';
import { Alert, Card } from 'antd';
import 'moment/locale/sk';
import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { translations } from '../../../../utils/LocalizedStrings';
import UserSignatureRequestListItem from './UserSignatureRequestList.item';

export function UserSignatureList({
  isLoading,
  showCreate,
  documents,
  refresh
}: {
  documents: object[];
  showCreate?: boolean;
  isLoading?: boolean;
  refresh: () => void;
}) {
  const [token, setToken] = useState('')
  useEffect(() => {
    Auth.currentSession().then(session => {
      const jwtToken = session.getAccessToken().getJwtToken()
      setToken(jwtToken)
    })
  })
  if (isLoading) {
    return <Alert message="Načítavam" type="info" />;
  }
  if (!isLoading && !showCreate && documents && documents.length > 0) {
    return (
      <>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell data-cell={translations.artifacts.OrderListBox.nameOfSro}>{translations.artifacts.OrderListBox.nameOfSro}</Table.HeaderCell>
            <Table.HeaderCell data-cell={translations.artifacts.OrderListBox.requester}>{translations.artifacts.OrderListBox.requester}</Table.HeaderCell>
            <Table.HeaderCell data-cell={translations.artifacts.OrderListBox.dateOfCreate}>{translations.artifacts.OrderListBox.dateOfCreate}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {documents.map((item: any) => (
            <UserSignatureRequestListItem
              token={token}
              data={item}
              key={`docitem-${item._id || item.name}`}
              refresh={refresh}
              labels={translations.artifacts?.OrderListBox ?? {
                nameOfSro: 'Názov SRO',
                requester: 'Žiadateľ',
                dateOfCreate: 'Vytvorené'
              }} />
          ))}
        </Table.Body>
      </>
    );
  }
  if (!isLoading && !showCreate && (!documents || documents.length === 0)) {
    return <Alert message="Neboli nájdené žiadne žiadosti." type="warning" />;
  }

  return null;
}

export function UserSignatureListHeader({

}: {

  }) {
  const [sortMenuVisible, setSortMenuVisible] = useState(false)
  const [filterMenuVisible, setFilterMenuVisible] = useState(false)
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);


  return (
    <>
      <Card className='userProfileOrdersTable'>
        <div className='userProfileOrdersTableHeader'>
          <div>
          </div>
        </div>
      </Card>
    </>
  );
}

